import React, { useEffect, useRef } from 'react'
import { withPrefix } from 'gatsby'
import Layout from '../../../components/layouts/layout'
import './sobre-el-programa.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import RegistrateAqui from '../../formularios/registrate-aqui'
import { GTMEvents } from '../../../lib/GTMevents'
import Helmet from 'react-helmet'
import {
  AhorraYaBanner,
  ComoHacerUsoDelPrograma,
  ConoceNuestrosEstablecimientosAliados,
  ResolvamosLasPreguntasFrecuentes,
} from '../../../components/aliados-comerciales/sobre-el-programa'

const SobrePrograma = () => {
  const sectionsRef = useRef({})

  const redirectAhorroYa = () => {
    window.open('https://www.ahorroya.pe/', 'security', 'noopener')
  }

  const scrollToSection = sectionId => {
    const navbarHeight = document.querySelector('header').offsetHeight
    const section = sectionsRef.current[sectionId]
    const sectionPosition = section.offsetTop
    const scrollPosition = sectionPosition - navbarHeight
    window.scrollTo({ top: scrollPosition, behavior: 'smooth' })
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollValue = window.scrollY || window.scrollTop
      const animationElement = document.querySelector(
        '.ahorroYa-how-to-use__steps-rod'
      )
      const textElement = document.querySelectorAll(
        '.ahorroYa-how-to-use__circle__step'
      )
      const contentElement = document.querySelectorAll(
        '.ahorroYa-how-to-use__content-without-circle'
      )

      if (animationElement !== null && scrollValue > 900) {
        animationElement.classList.add('animate')
        textElement.forEach((element, index) => {
          element.classList.add(`animate-step-${index + 1}`)
        })
        contentElement.forEach((element, index) => {
          element.classList.add(`animate-step-${index + 1}`)
        })
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Layout>
      <Helmet>
        <title>Conoce el Programa de Aliados Comerciales | Prima AFP</title>
        <meta
          name="title"
          content="Conoce el Programa de Aliados Comerciales | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Descubre sobre nuestros aliados comerciales y los beneficios que te otorga ser afiliado de Prima AFP."
          data-react-helmet="true"
        />
        <link
          rel="canonical"
          href="https://www.prima.com.pe/public-zone/aliados-comerciales/sobre-el-programa/"
        />
        <script type="application/ld+json">
          {`
            [
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Inicio",
                    "item": "https://www.prima.com.pe/public-zone/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Aliados Comerciales",
                    "item": "https://www.prima.com.pe/public-zone/aliados-comerciales/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Sobre el Programa",
                    "item": "https://www.prima.com.pe/public-zone/aliados-comerciales/sobre-el-programa/"
                  }
                ]
              }
            ]
          `}
        </script>

        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "FinancialService",
              "address": "C. Chinchón 980, San Isidro 15046",
              "name": "ahorroYa! Prima AFP",
              "description": "Un programa de ahorro voluntario que te permite ahorrar para tus metas a corto, mediano o largo plazo. Ofrece una tasa de interés competitiva y flexibilidad para elegir tus aportes."
            }
          `}
        </script>

        <script type="application/ld+json">
          {`
            [
              {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                  {
                    "@type": "Question",
                    "name": "¿Qué es el programa AhorroYa!?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Es un programa a través del cual podrás ahorrar parte de tus consumos en establecimientos aliados. AhorroYa! no es un programa de descuentos."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "¿Cómo funciona el programa AhorroYa!?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Puedes elegir que tu pensión se pague en 12 o 14 mensualidades al año; si eliges 14 mensualidades recibirás doble pago en los meses de Julio y Diciembre y el monto de la pensión será menor que si eliges 12 porque el pago anual es el mismo."
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "¿Qué es una cuenta de aportes voluntarios sin fin previsional?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Es una cuenta independiente de tu fondo obligatorio, y genera la rentabilidad del tipo de fondo donde se encuentra. Prima AFP enviará el estado de cuenta mensualmente vía email en donde se indicarán los aportes voluntarios derivados de tus consumos, y la rentabilidad obtenida.\n**Puedes retirar el dinero las veces que quieras sin penalidades, a través de la web o app de Prima AFP. El monto máximo para retiros por la web y app es de S/ 20,000.00. Para retirar cantidades mayores deberás registrar una solicitud de atención con nuestros ejecutivos a través de los canales antes mencionados.**"
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "¿Cómo le hago seguimiento a mis aportes?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Todos los aportes generados en un mes estarán acreditados en la cuenta de aportes voluntarios sin fin previsional del cliente en la última semana del mes siguiente de realizados los consumos.\n**Podrás hacer seguimiento desde nuestra web o app.**"
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "¿Cuál es la comisión y rentabilidad?",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "La cuenta de aportes voluntarios sin fin previsional esta afecta a la comisión de administración sobre el saldo administrado. Fondo 1: 0.10% mensual / Fondo 2: 0.13% mensual / Fondo 3: 0.16% mensual.\n**Las ganancias de capital (rentabilidad) están afectas al 5% de impuesto a la renta.**\n**La cuenta de aportes voluntarios sin fin previsional es embargable.**"
                    }
                  },
                  {
                    "@type": "Question",
                    "name": "Revisa los documentos informativos",
                    "acceptedAnswer": {
                      "@type": "Answer",
                      "text": "Cartilla informativa del programa AhorroYa!\n**Términos y condiciones de inscripción al Programa AhorroYa!**"
                    }
                  }
                ]
              }
            ]
          `}
        </script>
      </Helmet>

      <section className="ahorroYa-banner">
        <AhorraYaBanner scrollToSection={scrollToSection} />
      </section>

      <section
        ref={el => (sectionsRef.current['ahorroYa-register-section'] = el)}
        className="ahorroYa-register"
        id="ahorroYa-register-section"
      >
        <div className="ahorroYa__section-container_otp">
          <div className="ahorroYa-register__section_container">
            <RegistrateAqui />
          </div>
        </div>
      </section>
      <section
        ref={el => (sectionsRef.current['ahorroYa-how-to-use-section'] = el)}
        className="how-to-use"
        id="ahorroYa-how-to-use-section"
      >
        <ComoHacerUsoDelPrograma
          scrollToSection={scrollToSection}
          AhorroYaStepBtn={GTMEvents.AhorroYaStepBtn}
          redirectAhorroYa={redirectAhorroYa}
        />
      </section>

      <section
        ref={el => (sectionsRef.current['ahorroYa-partners-section'] = el)}
        className="partner-establishments"
        id="ahorroYa-partners-section"
      >
        <ConoceNuestrosEstablecimientosAliados />
      </section>
      <section
        ref={el => (sectionsRef.current['ahorroYa-questions-section'] = el)}
        className="ahorroYa-questions"
        id="ahorroYa-questions-section"
      >
        <ResolvamosLasPreguntasFrecuentes />
      </section>
    </Layout>
  )
}

export default SobrePrograma
